export { default as default } from './KitTouchableOption';
